import { featureModuleTypesEnum } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { ITEM_ROOT } from "odata-query";
import { getOrganizationNames } from "sources/admin";

const config = {
    organizationId: {
        // select
        label: "Организация",
        inputProps: { name: "organizationId" },
        url: (params) =>
            getOrganizationNames(params, {
                featureModuleTypes: { any: { [ITEM_ROOT]: featureModuleTypesEnum.TrackerLogsFiltering } },
            }),
        propName: "name",
        menuPortalTarget: document.body,
    },
    from: {
        label: "Дата начала",
        inPortal: true,
        validators: [requiredField],
        required: true,
        inputProps: { name: "from", type: "datetime" },
    },
    to: {
        label: "Дата окончания",
        inPortal: true,
        validators: [requiredField],
        required: true,
        inputProps: { name: "to", type: "datetime" },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
